<template>
    <div class="grid-content" v-fs-block>
        <div class="grid-item grid-item-full">
            <h3>Items</h3>
            <div v-if="!creditMemo.hasItems">No credit memo items.</div>
            <table class="table" v-else>
                <tbody>
                <tr>
                    <th class="width-half">Description</th>
                    <th class="text-right">Quantity</th>
                    <th class="text-right">Unit Price</th>
                    <th class="text-right">Total Price</th>
                    <th class="text-right">Credited</th>
                </tr>
                <tr v-for="item in items" :key="item.invoiceItem.id">
                    <td class="width-half">
                        <p>{{item.invoiceItem.product.name}}</p>
                        <p class="text-muted">
                            {{item.invoiceItem.description}}
                            <router-link :to="{name: 'invoice-details', params: {id: item.invoice.id}}">
                                (on Invoice #{{`${item.invoice.invoiceNumber}`.padStart(6, '0')}})
                            </router-link>
                        </p>
                    </td>
                    <td class="text-right is-numeric">{{item.invoiceItem.quantity}}</td>
                    <td class="text-right is-numeric">
                        {{item.invoiceItem.unitPrice | monetizeExplicit(creditMemo.currency)}}
                    </td>
                    <td class="text-right is-numeric">
                        {{item.invoiceItem.price | monetizeExplicit(creditMemo.currency)}}
                    </td>
                    <td class="text-right is-numeric">
                        {{item.totalCredit | monetizeExplicit(creditMemo.currency)}}
                    </td>
                </tr>
                <tr v-if="creditMemo.generalAdjustmentCredit">
                    <td class="width-half">
                        <p>General Adjustment</p>
                        <p class="text-muted">{{creditMemo.generalAdjustmentCredit.description}}</p>
                    </td>
                    <td class="text-right is-numeric">{{ $emptyInnerHTML() }}</td>
                    <td class="text-right is-numeric">{{ $emptyInnerHTML() }}</td>
                    <td class="text-right is-numeric">{{ $emptyInnerHTML() }}</td>
                    <td class="text-right is-numeric">
                        {{creditMemo.generalAdjustmentCredit.amount | monetizeExplicit(creditMemo.currency)}}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState('creditMemos', ['creditMemo', 'invoices']),
            items() {
                const allocationsWithItems = this.creditMemo.allocations.filter(allocation => allocation.items.length > 0);

                return allocationsWithItems.flatMap((allocation) => {
                    const invoiceModel = this.invoices.find(invoice => invoice.id === allocation.invoiceId);

                    return allocation.items.map((allocationItem) => {
                        const invoiceItemModel = invoiceModel.items.find(invoiceItem => invoiceItem.id === allocationItem.invoiceItemId);

                        return {
                            invoice: invoiceModel,
                            invoiceItem: invoiceItemModel,
                            totalCredit: allocationItem.totalCredit,
                        };
                    });
                });
            },
        },
    };
</script>
